import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchCatalogItem = (id: string) => {
  const response = useQuery({
    queryKey: ['catalogItem', id],
    queryFn: () => api.referral.fetchCatalogItem(id),
    enabled: !!id, // Запрос выполняется только если есть id
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить данные события',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
